import { useBranding, logoSrc } from "@/context/BrandingContext";

export const BrandHeader = ({ compact = false }) => {
  const { branding } = useBranding();
  const logo = logoSrc(branding?.logos?.sidebar);
  const name = branding?.app_name ?? "clubmagazin";
  const sub = branding?.app_subtitle ?? "REDAKTIONSSYSTEM";
  if (compact) {
    return logo
      ? <img src={logo} alt={name} className="h-8 max-w-[160px] object-contain" data-testid="mobile-brand-logo" />
      : <span className="font-display font-extrabold" data-testid="mobile-brand-name">{name}</span>;
  }
  return (
    <div data-testid="sidebar-brand">
      {logo && <img src={logo} alt={name} className="max-h-20 max-w-full object-contain mb-6" data-testid="sidebar-logo" />}
      {name && <div className="font-display text-2xl font-extrabold text-white tracking-tight leading-tight" data-testid="sidebar-app-name">{name}</div>}
      {sub && <div className="text-[10px] tracking-[0.25em] text-slate-400 mt-1.5 uppercase" data-testid="sidebar-app-subtitle">{sub}</div>}
    </div>
  );
};
